// this is an autogenerated file from DesignSystem/CommsThread/Content/mutation_send_in_app.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_CommsThread_Content(
  $thread_id: uuid!
  $location_id: uuid!
  $message: String!
  $email: String
  $is_secure: Boolean!
  $status: comms_events_statuses_types_enum_action!
  $attachments: [comms_events_in_app_and_status_attachment!]
  $tags: jsonb
) {
  comms_events_in_app_send_and_events_status_create(
    thread_id: $thread_id
    location_id: $location_id
    is_secure: $is_secure
    message: $message
    status: $status
    email: $email
    attachments: $attachments
    tags: $tags
  ) {
    event_in_app_id
  }
}

`